import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function useLegalModals() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return {
    activeModal,
    setActiveModal
  };
}
export function LegalLinks({
  onPrivacy,
  onTerms,
  className = ''
}: {
  onPrivacy: () => void;
  onTerms: () => void;
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-6 text-sm ${className}`} data-id="element-138">
      <button onClick={onPrivacy} className="text-white/60 hover:text-white transition-colors underline underline-offset-2" data-id="element-139">
        Política de Privacidad
      </button>
      <span className="text-white/30" data-id="element-140">|</span>
      <button onClick={onTerms} className="text-white/60 hover:text-white transition-colors underline underline-offset-2" data-id="element-141">
        Términos de Servicio
      </button>
    </div>;
}
export function LegalModals({
  activeModal,
  onClose
}: {
  activeModal: ModalType;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-142">
      {activeModal && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-143">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-144" />
          <motion.div className="relative bg-white rounded-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto p-8 shadow-2xl" initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} data-id="element-145">
            <button onClick={onClose} className="absolute top-4 right-4 text-text-medium hover:text-text-dark transition-colors" data-id="element-146">
              <XIcon className="w-5 h-5" data-id="element-147" />
            </button>

            {activeModal === 'privacy' && <div className="text-left" data-id="element-148">
                <h3 className="text-2xl font-heading font-semibold text-text-dark mb-4" data-id="element-149">
                  Política de Privacidad
                </h3>
                <div className="text-text-medium space-y-3 text-sm leading-relaxed" data-id="element-150">
                  <p data-id="element-151">
                    Tu privacidad es importante para nosotros. Esta política
                    describe cómo recopilamos, usamos y protegemos tu
                    información personal.
                  </p>
                  <p data-id="element-152">
                    <strong data-id="element-153">Información que recopilamos:</strong> Nombre, correo
                    electrónico y datos de pago necesarios para procesar tu
                    compra.
                  </p>
                  <p data-id="element-154">
                    <strong data-id="element-155">Uso de la información:</strong> Utilizamos tu
                    información únicamente para procesar tu pedido y enviarte el
                    producto digital adquirido.
                  </p>
                  <p data-id="element-156">
                    <strong data-id="element-157">Protección de datos:</strong> Implementamos medidas
                    de seguridad para proteger tu información personal contra
                    acceso no autorizado.
                  </p>
                  <p data-id="element-158">
                    <strong data-id="element-159">Contacto:</strong> Si tienes preguntas sobre nuestra
                    política de privacidad, no dudes en contactarnos.
                  </p>
                </div>
              </div>}

            {activeModal === 'terms' && <div className="text-left" data-id="element-160">
                <h3 className="text-2xl font-heading font-semibold text-text-dark mb-4" data-id="element-161">
                  Términos de Servicio
                </h3>
                <div className="text-text-medium space-y-3 text-sm leading-relaxed" data-id="element-162">
                  <p data-id="element-163">
                    Al realizar tu compra, aceptas los siguientes términos y
                    condiciones.
                  </p>
                  <p data-id="element-164">
                    <strong data-id="element-165">Producto digital:</strong> Este es un producto
                    digital en formato PDF. Una vez completada la compra,
                    recibirás acceso inmediato para descargarlo.
                  </p>
                  <p data-id="element-166">
                    <strong data-id="element-167">Uso personal:</strong> El contenido del ebook es
                    para uso personal y no puede ser redistribuido, copiado o
                    compartido sin autorización.
                  </p>
                  <p data-id="element-168">
                    <strong data-id="element-169">Garantía de satisfacción:</strong> Si no estás
                    satisfecha con tu compra, contáctanos y trabajaremos para
                    resolver cualquier inconveniente.
                  </p>
                  <p data-id="element-170">
                    <strong data-id="element-171">Limitación de responsabilidad:</strong> La
                    información proporcionada en este ebook es de carácter
                    informativo y no sustituye el consejo médico profesional.
                  </p>
                </div>
              </div>}
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}